export default {
    title: 'Cotizaciones',
    subtitle: 'Gestiona las solicitudes de cotización recibidas por correo electrónico',
    settingsButton: 'Configuración',
    
    list: {
        loading: 'Cargando cotizaciones...',
        noQuotes: 'No se encontraron cotizaciones',
        searchPlaceholder: 'Buscar cotizaciones...',
        lastUpdate: 'Última actualización',
        viewAll: 'Ver Todas las Cotizaciones',
        filters: {
            allStatuses: 'Todos los Estados',
        },
        headers: {
            from: 'De',
            subject: 'Asunto',
            receivedAt: 'Recibido',
            status: 'Estado',
        },
    },
    
    status: {
        pending: 'Pendiente',
        autoResponded: 'Respuesta Automática',
        requiresReview: 'Requiere Revisión',
        responded: 'Respondido',
        archived: 'Archivado',
        completed: 'Completado',
        cancelled: 'Cancelado',
    },
    
    shipperStatus: {
        accepted: 'Aceptado por Shipper',
        rejected: 'Rechazado por Shipper',
        modificationRequested: 'Modificación Solicitada por Shipper',
    },
    
    badges: {
        autoResponded: 'Auto-respondido',
        requiresReview: 'Requiere Revisión',
    },
    
    extracted: {
        product: 'Producto',
        origin: 'Origen',
        destination: 'Destino',
        quantity: 'Cantidad',
        unit: 'Unidad',
        pickupDate: 'Fecha de Recogida',
        deliveryDate: 'Fecha de Entrega',
        estimatedValue: 'Valor Estimado',
        equipmentType: 'Tipo de Equipamiento',
        temperatureRequirements: 'Requisitos de Temperatura',
        specialRequirements: 'Requisitos Especiales',
        customsRequirements: 'Requisitos Aduaneros',
    },
    
    detail: {
        tabs: {
            email: 'Email Original',
            extractedData: 'Datos Extraídos',
            responseEmail: 'Email de Respuesta',
            createResponse: 'Crear Respuesta',
            thread: 'Thread',
        },
        email: {
            from: 'De',
            receivedAt: 'Recibido el',
            respondedAt: 'Respondido el',
            body: 'Cuerpo del Email',
        },
        responseEmail: {
            subject: 'Asunto',
            sentAt: 'Enviado el',
            body: 'Cuerpo del Email',
        },
        createResponse: {
            title: 'Crear Email de Respuesta',
            subject: 'Asunto',
            subjectPlaceholder: 'Ej. Cotización para transporte de {{product}}',
            body: 'Cuerpo del Email',
            bodyPlaceholder: 'Ingrese el texto de la respuesta...',
            bodyHint: 'Use {{variable}} para insertar datos dinámicos. Puede hacer referencia a los datos extraídos a la derecha.',
            extractedDataReference: 'Referencia de Datos Extraídos',
            saveDraft: 'Guardar Borrador',
            send: 'Enviar Respuesta',
            sending: 'Enviando...',
            titleCounterProposal: 'Crear Contraoferta',
            successTitle: 'Cotización enviada con éxito',
            successMessage: 'La cotización ha sido enviada correctamente al Shipper. Recibirá una notificación y podrá visualizar tu propuesta en la sección de Cotizaciones.',
            price: 'Precio',
            pricePlaceholder: '0.00',
            validity: 'Validez (días)',
            validityPlaceholder: '30',
            terms: 'Términos y Condiciones',
            termsPlaceholder: 'Cotización válida por 30 días. Se requiere pago anticipado.',
        },
        extractedData: {
            title: 'Datos Estructurados Extraídos',
        },
        thread: {
            freightForwarderLabel: 'Agente de Carga',
            shipperLabel: 'Shipper',
            carrierLabel: 'Naviera',
            bookingEmailBody: 'Se ha generado un email de solicitud de booking a la naviera basado en esta cotización.',
            bookingCta: 'El shipper ha aceptado la cotización. Puedes solicitar el booking a la naviera.',
            bookingRequested: 'Booking solicitado',
            bookingRequestAction: 'Solicitar booking a la naviera',
            requestingBooking: 'Solicitando...',
            requestingBookingMessage: 'Solicitando número de booking al transportista...',
            bookingNumberReceived: 'Número de booking recibido',
            bookingNumber: 'Número de Booking',
            simulateBookingNumber: 'Simular',
            sharingBookingNumber: 'Compartiendo...',
            shareBookingNumber: 'Compartir número de booking con Shipper',
            bookingShareSuccessTitle: 'Número de booking compartido con éxito',
            bookingShareSuccessMessage: 'El número de booking ha sido compartido correctamente con el Shipper. Recibirá una notificación y podrá visualizar el número de booking en la sección de Cotizaciones.',
        },
    },
    processing: {
        currentStep: 'Procesando',
        steps: {
            analyzing: 'Analizando texto del email',
            identifying: 'Identificando producto',
            extracting: 'Extrayendo datos estructurados',
            calculating: 'Calculando costos',
            applying: 'Aplicando reglas',
            generating: 'Generando respuesta',
        },
    },
    
    dashboard: {
        title: 'Panel de Control',
        subtitle: 'Resumen de tus cotizaciones y estadísticas',
        stats: {
            total: 'Total de Cotizaciones',
            pending: 'Pendiente',
            autoResponded: 'Respuesta Automática',
            requiresReview: 'Requiere Revisión',
            responded: 'Respondido',
            archived: 'Archivado',
        },
        autoResponded: 'Respuesta Automática',
        manual: 'Manual',
        charts: {
            statusDistribution: 'Distribución por Estado',
            autoVsManual: 'Respuesta Automática vs Manual',
        },
        recentQuotes: {
            title: 'Cotizaciones Recientes',
            description: 'Últimas solicitudes de cotización recibidas',
            viewAll: 'Ver Todas',
        },
        noQuotes: 'No hay cotizaciones disponibles',
    },
    
    settings: {
        title: 'Configuración de Cotizaciones',
        subtitle: 'Configura reglas, precios y plantillas de correo electrónico para la gestión automática de cotizaciones',
        tabs: {
            rules: 'Reglas',
            pricing: 'Precios',
            templates: 'Plantillas de Email',
        },
        
        rules: {
            title: 'Reglas de Clasificación',
            description: 'Define reglas en lenguaje natural para identificar y clasificar solicitudes de cotización',
            create: 'Crear Regla',
            edit: 'Editar Regla',
            deleteConfirm: '¿Estás seguro de que deseas eliminar esta regla?',
            active: 'Activa',
            inactive: 'Inactiva',
            noRules: 'No hay reglas configuradas',
            naturalLanguageRule: 'Regla de Lenguaje Natural',
            autoResponseConditions: 'Condiciones de Respuesta Automática',
            form: {
                name: 'Nombre de la Regla',
                namePlaceholder: 'Ej. Regla de Aguacate',
                description: 'Descripción',
                descriptionPlaceholder: 'Descripción opcional de la regla',
                naturalLanguageRule: 'Regla de Lenguaje Natural',
                naturalLanguageRulePlaceholder: 'Ej. Identificar solicitudes para transporte de aguacate...',
                naturalLanguageRuleHint: 'Describe en lenguaje natural cómo identificar este tipo de solicitud',
                autoResponseConditions: 'Condiciones de Respuesta Automática',
                addCondition: 'Agregar Condición',
                conditionPlaceholder: 'Ej. si el producto solicitado es aguacate',
                isActive: 'Regla activa',
                isActiveLabel: 'Activa esta regla para habilitar la clasificación automática de solicitudes',
            },
        },
        
        pricing: {
            title: 'Configuración de Precios',
            description: 'Configura buy rate, margin y componentes de sell rate para el cálculo de cotizaciones',
            create: 'Crear Configuración',
            edit: 'Editar Configuración',
            deleteConfirm: '¿Estás seguro de que deseas eliminar esta configuración?',
            noSettings: 'No hay configuraciones',
            default: 'Configuración Predeterminada',
            buyRate: 'Buy Rate',
            margin: 'Margen',
            components: 'Componentes',
            componentsCount: 'componentes',
            sellRateComponents: 'Componentes de Sell Rate',
            marginType: {
                percentage: 'Porcentaje',
                currency: 'Moneda',
            },
            form: {
                buyRate: 'Buy Rate',
                baseCurrency: 'Moneda Base',
                marginValue: 'Valor del Margen',
                marginType: 'Tipo de Margen',
                sellRateComponents: 'Componentes de Sell Rate',
                addComponent: 'Agregar Componente',
                component: 'Componente',
                componentName: 'Nombre del Componente',
                componentNamePlaceholder: 'Ej. Costo de combustible',
                componentValue: 'Valor',
                componentType: 'Tipo',
                componentDescription: 'Descripción',
                componentDescriptionPlaceholder: 'Descripción opcional',
                noComponents: 'No se agregaron componentes',
            },
        },
        
        templates: {
            title: 'Plantillas de Email',
            description: 'Crea y edita plantillas de correo electrónico para respuestas automáticas de cotizaciones',
            create: 'Crear Plantilla',
            edit: 'Editar Plantilla',
            deleteConfirm: '¿Estás seguro de que deseas eliminar esta plantilla?',
            noTemplates: 'No hay plantillas configuradas',
            subject: 'Asunto',
            body: 'Cuerpo',
            draftingInstructions: 'Instrucciones de Redacción',
            form: {
                name: 'Nombre de la Plantilla',
                namePlaceholder: 'Ej. Plantilla de Aguacate',
                subject: 'Asunto del Email',
                subjectPlaceholder: 'Ej. Cotización para transporte de {{product}}',
                subjectHint: 'Usa {{variable}} para insertar datos dinámicos',
                body: 'Cuerpo del Email',
                bodyPlaceholder: 'Ingresa el cuerpo del email...',
                bodyHint: 'Usa {{variable}} para insertar datos dinámicos. Ej. {{recipientName}}, {{totalPrice}}',
                draftingInstructions: 'Instrucciones de Redacción',
                addInstruction: 'Agregar Instrucción',
                instructionPlaceholder: 'Ej. llama al destinatario por nombre',
                noInstructions: 'No se agregaron instrucciones',
                editTab: 'Editar',
                previewTab: 'Vista Previa',
                noPreview: 'Vista previa no disponible',
            },
        },
    },
    
    shipper: {
        list: {
            loading: 'Cargando solicitudes...',
            noRequests: 'No se encontraron solicitudes',
            searchPlaceholder: 'Buscar solicitudes...',
            createNew: 'Crear Nueva Solicitud',
            title: 'Solicitudes de Cotización Enviadas',
            description: 'Lista de solicitudes de cotización enviadas a agentes de carga',
            edit: 'Editar',
            view: 'Ver',
            cancel: 'Cancelar',
            confirmCancelMessage: '¿Estás seguro de que deseas cancelar esta solicitud?',
            confirm: 'Confirmar',
            filters: {
                allStatuses: 'Todos los Estados',
            },
            headers: {
                subject: 'Asunto',
                sentAt: 'Enviada el',
                recipients: 'Destinatarios',
                responses: 'Cotizaciones Recibidas',
                status: 'Estado',
                actions: 'Acciones',
            },
            recipientsCount: 'destinatarios',
            responsesCount: 'cotizaciones',
        },
        status: {
            pending: 'Pendiente',
            responded: 'Respondido',
            completed: 'Completado',
            cancelled: 'Cancelado',
        },
        form: {
            createTitle: 'Crear Nueva Solicitud',
            editTitle: 'Editar Solicitud',
            subject: 'Asunto',
            subjectPlaceholder: 'Ej. Solicitud de cotización para transporte...',
            body: 'Cuerpo del Email',
            bodyPlaceholder: 'Ingresa el texto de la solicitud de cotización...',
            recipients: 'Destinatarios (Agente de Carga)',
            recipientsPlaceholder: 'Selecciona agentes de carga...',
            extractedDataTitle: 'Datos de la Solicitud',
            send: 'Enviar Solicitud',
            update: 'Actualizar',
        },
        detail: {
            loading: 'Cargando...',
            notFound: 'Solicitud no encontrada',
            back: 'Atrás',
            sentAt: 'Enviada el',
            edit: 'Editar',
            cancel: 'Cancelar',
            confirmCancelMessage: '¿Estás seguro de que deseas cancelar esta solicitud?',
            confirm: 'Confirmar',
            requestDetails: 'Detalles de la Solicitud',
            subject: 'Asunto',
            body: 'Cuerpo del Email',
            recipientsTitle: 'Destinatarios',
            extractedData: 'Datos de la Solicitud',
            receivedQuotes: 'Cotizaciones Recibidas',
            tabs: {
                details: 'Detalle de la Solicitud',
                responses: 'Cotizaciones Recibidas',
            },
            confirmCancel: {
                title: 'Confirmar Cancelación',
                message: '¿Estás seguro de que deseas cancelar esta solicitud de cotización?',
                confirm: 'Confirmar',
            },
            checkingQuotes: 'Comprobando nuevas cotizaciones...',
            newQuotesAvailable: '¡Nuevas cotizaciones disponibles!',
            newQuoteReceived: 'Has recibido una nueva respuesta de cotización',
            viewNewQuote: 'Ver nueva cotización',
            readyToComplete: 'Puedes completar esta solicitud',
            readyToCompleteDescription: 'Hay una o más cotizaciones aceptadas. Puedes marcar la solicitud como completada y simular la creación de contenedores basados en estas cotizaciones.',
            waitingForBookingNumber: 'Esperando número de booking',
            waitingForBookingNumberDescription: 'Debes esperar que al menos un Freight Forwarder comparta el número de booking antes de poder completar la solicitud.',
            completeRequest: 'Completar solicitud',
            completeRequestTitle: 'Completar solicitud de cotización',
            completeRequestMessage: 'La solicitud será marcada como completada. El sistema simulará la creación de uno o más contenedores basados en las cotizaciones aceptadas.',
            completeRequestConfirm: 'Confirmar completamiento',
            creatingContainer: 'Creando contenedor...',
            creatingContainerMessage: 'Estamos creando el contenedor basado en las cotizaciones aceptadas. Por favor espera...',
            recipients: {
                pending: 'Pendiente',
                respondedAccepted: 'Aceptado',
                respondedRejected: 'Rechazado',
                respondedModified: 'Modificación solicitada',
                respondedAt: 'Respondido el',
                sendReminder: 'Enviar recordatorio',
                sendReminderTitle: 'Enviar recordatorio',
                sendReminderMessage: '¿Quieres enviar un recordatorio a {{name}} ({{email}})?',
                sendingReminder: 'Enviando...',
                confirmSendReminder: 'Enviar recordatorio',
            },
        },
        responses: {
            noResponses: 'Aún no se han recibido cotizaciones',
            selected: 'Seleccionado',
            receivedAt: 'Recibido el',
            price: 'Precio',
            validity: 'Validez',
            days: 'días',
            viewDetails: 'Detalles',
            complete: 'Marcar como Completado',
            detailsTitle: 'Detalles de la Cotización',
            from: 'De',
            subject: 'Asunto',
            body: 'Cuerpo del Email',
            terms: 'Términos y Condizioni',
            accept: 'Aceptar',
            reject: 'Rechazar',
            requestModification: 'Solicitar Modificación',
            accepted: 'Aceptada',
            rejected: 'Rechazada',
            modificationRequested: 'Modificación Solicitada',
            actions: 'Acciones',
            confirmAcceptTitle: 'Confirmar aceptación de cotización',
            confirmAcceptMessage: '¿Estás seguro de que deseas aceptar esta cotización? Aún puedes aceptar otras cotizaciones para rutas diferentes del mismo envío.',
            confirmAcceptConfirm: 'Confirmar aceptación',
            modificationEditorTitle: 'Solicitud de modificación',
            modificationSubject: 'Asunto',
            modificationBody: 'Texto de solicitud de modificación',
            modificationBodyPlaceholder: 'Describe las modificaciones solicitadas (ej: precio, condiciones, tiempos)...',
            modificationSend: 'Enviar solicitud de modificación',
            modificationSubjectDefault: 'Solicitud de modificación',
            thread: 'Hilo de Mensajes',
            originalQuote: 'Cotización Original',
            you: 'Tú',
            counterProposal: 'Contrapropuesta',
            bookingNumber: 'Número de Booking',
            bookingNumberRequested: 'Solicitud en curso...',
            bookingNumberShared: 'El Freight Forwarder ha compartido el número de booking para esta cotización aceptada.',
            bookingNumberPending: 'El Freight Forwarder está solicitando el número de booking al transportista. Recibirás una notificación cuando esté disponible.',
            received: 'Recibido',
            tabs: {
                thread: 'Hilo',
                extractedData: 'Datos Extraídos',
            },
        },
    },
};

